<template>
  <div>
    <v-layout>
      <v-flex xs12 md6 v-for="col in getColArray()" :key="`col-${col}`">
        <v-card
          class="card-wrap"
          :class="{
            'scroll-wrapper': isMobile
          }"
        >
          <template v-for="(item, index) in items">
            <v-layout
              align-center
              class="select-row"
              v-if="getColVisible(col, index)"
              :key="item.time"
            >
              <v-flex xs5>
                <v-checkbox
                  :value="item.selected"
                  :label="item.time"
                  :disabled="disabled"
                  @change="onClick(item.time)"
                  hide-details
                ></v-checkbox>
              </v-flex>
              <v-flex xs7>
                <v-radio-group
                  :value="item.suffix"
                  :column="false"
                  @change="val => onClickSuffix(val, item.time)"
                >
                  <template v-for="suffix in suffixes">
                    <v-radio
                      :disabled="disabled || !item.selected"
                      :label="suffix"
                      :value="suffix"
                      :key="suffix"
                    ></v-radio>
                  </template>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      suffixes: [null, "以降"]
    };
  },
  computed: {
    items: {
      get() {
        return [
          this.getCurrentValue("午前"),
          this.getCurrentValue("午後")
        ].concat(
          Array.apply(0, Array(26)).map((x, y) => {
            const time = moment()
              .hour(7)
              .minute(0)
              .add(y * 30, "minute")
              .format("HH:mm");

            return this.getCurrentValue(time);
          })
        );
      }
    },
    select: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit(
          "input",
          value.sort((x, y) => {
            const sortX = /[0-9][0-9]:[0-9][0-9]/.test(x.time)
              ? x.time
              : "00:00" + x.time;
            const sortY = /[0-9][0-9]:[0-9][0-9]/.test(y.time)
              ? y.time
              : "00:00" + y.time;
            if (sortX < sortY) return -1;
            if (sortX > sortY) return 1;
            return 0;
          })
        );
      }
    },
    isMobile: {
      get() {
        return this.$vuetify.breakpoint.smAndDown;
      }
    }
  },
  methods: {
    getColCount() {
      return this.$vuetify.breakpoint.smAndDown ? 1 : 2;
    },
    getColArray() {
      return Array.apply(0, Array(this.getColCount())).map((x, y) => y + 1);
    },
    getColVisible(col, index) {
      if (this.isMobile) return true;

      const colCount = this.getColCount();
      return (
        Math.floor(index / Math.floor(this.items.length / colCount)) + 1 === col
      );
    },
    getCurrentValue(time) {
      return {
        time: time,
        selected: this.value.some(item => item.time === time),
        suffix: this.value.some(item => item.time === time)
          ? this.value.find(item => item.time === time).suffix
          : null
      };
    },
    onClick(item) {
      if (this.value.some(select => select.time === item)) {
        this.select = this.value.filter(select => select.time !== item);
      } else {
        const dummy = Array.from(this.value);
        dummy.push({
          time: item,
          suffix: null
        });
        this.select = dummy;
      }
    },
    onClickSuffix(suffix, item) {
      if (this.value.some(select => select.time === item)) {
        this.select = Array.from(
          this.value.map(select => {
            if (select.time === item) {
              return Object.assign(select, {
                suffix: suffix
              });
            }
            return select;
          })
        );
      }
    }
  }
};
</script>

<style scoped lang="scss">
.card-wrap {
  padding: 0.5rem 0;
}
.scroll-wrapper {
  height: 12rem;
  overflow-y: scroll;
}
.select-row {
  padding: {
    left: 1.5rem;
    right: 1.5rem;
  }
  &:nth-child(4n + 3) {
    background-color: #e9f2f5;
  }
  &:nth-child(4n + 4) {
    background-color: #e9f2f5;
  }
}
/deep/ {
  .v-input.v-input--selection-controls {
    margin-top: 0 !important;
  }
  .v-messages {
    display: none !important;
  }
  .v-input--radio-group {
    .v-input__slot {
      margin-bottom: 0;
    }
  }
}
</style>
